<div class="mb-29 mct-flex mct-row mct-gap-27">
  <div class="mct-flex mct-row mct-justify-start mct-items-center">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" [routerLink]="['/form-builder/forms']">
      {{ 'form-builder.form-submissions.back-to-forms' | translate | uppercase }}
    </button>
  </div>
  <div class="form-header mct-flex mct-row mct-justify-start mct-items-center mct-gap-5">
    <span class="form-name">{{ formTemplate?.Title }}</span>
    <span>{{ formTypeName }}</span>
    <span>#{{ form?.Id }}</span>
    <span></span>
  </div>
</div>

<wl-form-submission-search-params [(searchParams)]="searchParams">
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="search()">
    {{ 'common.run-this-search' | translate | uppercase }}
  </button>
</wl-form-submission-search-params>

<div class="mv-27">
  {{ 'common.there-are' | translate | ucfirst }}
  <strong>
    {{ searchResult?.TotalCount ? searchResult.TotalCount : 0 }}
    {{ 'form-builder.form-submissions.form-submissions' | translate }}
  </strong>
  {{ 'form-builder.form-submissions.in-this-date-range' | translate }}
</div>

<div class="atlas-table">
  <div class="mct-flex mct-row-reverse">
    <a (click)="exportFormSubmissions()">{{ 'form-builder.form-submissions.event-submissions-export' | translate | ucfirst }}</a>
  </div>
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [globalFilterFields]="['DateCreated', 'Profile']"
    [loading]="loading"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="DateCreated" style="width: 190px">
          {{ 'common.date' | translate | ucfirst }}
          <p-sortIcon field="DateCreated"></p-sortIcon>
        </th>
        <th pSortableColumn="PrimaryProfileId">
          {{ 'form-builder.form-submissions.submitting-profile' | translate | ucfirst }}
          <p-sortIcon field="PrimaryProfileId"></p-sortIcon>
        </th>
        <th>
          {{ 'form-builder.form-submissions.invoice' | translate | ucfirst }}
        </th>
        <th>
          {{ 'form-builder.form-submissions.invoice-amount' | translate | ucfirst }}
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
      <tr>
        <th>
          <wl-date-selector
            appendTo="body"
            [(ngModel)]="searchParams.DateCreated"
            [showButtonBar]="true"
            (ngModelChange)="filterChanged()"
          ></wl-date-selector>
        </th>
        <th>
          <input
            pInputText
            placeholder="{{ 'form-builder.form-submissions.filter-by-profile-name' | translate | ucfirst }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.ProfileName"
            (input)="filterChanged()"
          />
        </th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-formResponse>
      <tr>
        <td>{{ formResponse.DateCreated | date: 'MM/dd/yyyy' }}</td>
        <td>
          <div class="mct-flex mct-row mct-justify-start mct-items-center">
            <wl-profile-avatar size="xs" [profileId]="formResponse.PrimaryProfileId"></wl-profile-avatar>
            <div *ngIf="formResponse.PrimaryProfileId > 0; else noProfile">
              <a class="ml-10 mr-5" [routerLink]="['/profile', formResponse.PrimaryProfileId]">{{
                formResponse.PrimaryProfileReportName
              }}</a>
              <span class="light-text">({{ formResponse.PrimaryProfileId }})</span>
            </div>
            <ng-template #noProfile>
              <div class="ml-10 mr-5">{{ getResponseName(formResponse) }} (0)</div>
            </ng-template>
          </div>
        </td>
        <td>
          <a [routerLink]="['/revenue/invoice', formResponse.InvoiceNum]">{{ formResponse.InvoiceNum }}</a>
        </td>
        <td>
          <div *ngIf="formResponse.InvoiceNum">
            {{ invoiceAmounts.get(formResponse.InvoiceNum) | atlasCurrency }}
          </div>
        </td>
        <td class="t-ac">
          <action-button
            styleClass="atlas-btn atlas-btn-primary"
            [label]="'common.actions' | translate | uppercase"
            [items]="actionItemsForFormResponse(formResponse)"
          >
          </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<wl-form-submission-view-modal
  [showSubmissionModal]="showSubmissionModal"
  [submissionResponse]="submissionResponse"
  (closeSubmissionModal)="closeSubmissionModal($event)"
  [formTemplate]="formTemplate"
></wl-form-submission-view-modal>

<p-confirmDialog
  #cd
  key="deleteFormSubmissionCD"
  header="{{ 'form-builder.form-submissions.delete-this-form' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<p-dialog modal="true" styleClass="atlas-dialog-m" position="top" [closable]="false" [(visible)]="showProfileDialog">
  <ng-template pTemplate="header">
    <h4>{{ 'form-builder.form-submissions.link-a-profile-header' | translate | ucfirst }}</h4>
  </ng-template>
  <ng-container>
    <div [wl-busy-overlay]="linkingProfile">
      <wl-profile-search-and-select (profileSelected)="profileSelected($event)"></wl-profile-search-and-select>
    </div>
  </ng-container>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-center">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="showProfileDialog = false">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
